/**
 * Build-time constant. Set on the soft-launch day (T+6 in roadmap).
 * For dev/test, use a fixed past date so puzzleNumber > 0.
 */
export const LAUNCH_DATE = '2026-06-15';

/**
 * Returns the puzzle number for a given calendar date.
 * Day 1 is LAUNCH_DATE itself, day 2 is the day after, etc.
 * Dates before launch return 0 or negative.
 */
export function puzzleNumber(date: string): number {
  const launch = parseDateUTC(LAUNCH_DATE);
  const target = parseDateUTC(date);
  const diffMs = target.getTime() - launch.getTime();
  const diffDays = Math.round(diffMs / 86_400_000);
  return diffDays + 1;
}

export function isBeforeLaunch(date: string): boolean {
  return puzzleNumber(date) <= 0;
}

function parseDateUTC(date: string): Date {
  const [y, m, d] = date.split('-').map(Number) as [number, number, number];
  return new Date(Date.UTC(y, m - 1, d));
}
